import firebase from 'firebase/app';
import 'firebase/firestore';
import { v5 as uuid } from 'uuid'
import firebaseConfig from './firebase_config';

const app = firebase.initializeApp(firebaseConfig)
const db = app.firestore()

const SCHOOLS = 'schools'

export async function duplicateGraph() {
    const asset = await db.collection(SCHOOLS).doc('e5abIXEqXZc3x5I0hYhd').collection('assets').doc('JbBUIvbmvqmOe9XCXbeM').get()
    const myData = asset.data()
    await db.collection(SCHOOLS).doc('e5abIXEqXZc3x5I0hYhd').collection('assets').add({
        ...myData
    })

}
export async function createUser(user) {
    if (user) {
        const id = uuid(user.sub, uuid.DNS)
        const existingUser = await db.collection('users').doc(id).get()
        if(!existingUser.exists || existingUser.data().role === undefined){
            await db.collection('users').doc(id).set({
                school: 'e5abIXEqXZc3x5I0hYhd',
                role: 'pupil',
                ...user
            })
        }
        return  (await db.collection('users').doc(id).get()).data();
    }
}
export function fetchUsers() {
    return db.collection('users')
}
export function fetchUserById(userId) {
    return db.collection('users').doc(userId)
}

export function createSchool(name, address) {
    return db.collection(SCHOOLS).add({ name, address })
}

export function fetchSchools() {
    return db.collection(SCHOOLS)
}

export function fetchSchool(schoolId) {
    return db.collection(SCHOOLS).doc(schoolId)
}

export function fetchAssets(schoolId) {
    return db.collection(SCHOOLS).doc(schoolId).collection('assets')
}

export function fetchAsset(schoolId, assetId) {
    return db.collection(SCHOOLS).doc(schoolId).collection('assets').doc(assetId)
}

export function createAsset(schoolId, asset) {
    return db.collection(SCHOOLS).doc(schoolId).collection('assets').add(asset)
}

export function updateAsset(schoolId, assetId, asset) {
    return db.collection(SCHOOLS).doc(schoolId).collection('assets').doc(assetId).set(asset)
}

export function createClass(schoolId, name) {
    return db.collection(SCHOOLS).doc(schoolId).collection('classes').add({ name })
}

export function fetchClassesOfSchool(schoolId) {
    return db.collection(SCHOOLS).doc(schoolId).collection('classes')
}

export function fetchClass(schoolId, classId) {
    return db.collection(SCHOOLS).doc(schoolId).collection('classes').doc(classId)
}

export function fetchPupilOfClass(schoolId, classId, pupilId) {
    return db.collection(SCHOOLS).doc(schoolId).collection('classes').doc(classId).collection('pupils').doc(pupilId)
}
export function setGraphOfPupil(schoolId, classId, pupilId, nodes, edges) {
    return db.collection(SCHOOLS).doc(schoolId).collection('classes').doc(classId).collection('pupils').doc(pupilId).set({
        nodes,
        edges
    }, {merge: true})
}

export async function fetchPupilsOfClass(schoolId, classId) {
    console.log(`fetchPupilsOfClass schoolId=${schoolId} classId=${classId}`)
    const pupilRefs = await db.collection(SCHOOLS).doc(schoolId).collection('classes').doc(classId).collection('pupils').get()
    const pupils = await Promise.all(pupilRefs.docs.map(p => fetchUserById(p.id).get()))
    return pupils.map(doc => {
        const $data = doc.data();
        return {
            $id: doc.id,
            ...$data
        };
    })
}

export async function assignPupilToClass(pupilId, schoolId, classId) {
    await db.collection(SCHOOLS).doc(schoolId).collection('classes').doc(classId).collection('pupils').doc(pupilId).set({
        pupilId
    })
}

export async function assignParentToPupil(parentId, pupilId, schoolId) {
    await db.collection(SCHOOLS).doc(schoolId).collection('pupils').doc(pupilId).collection('parents').doc(parentId).set({
        parentId
    })
}

export async function assignTeacherToClass(teachId, schoolId, classId) {
    await db.collection(SCHOOLS).doc(schoolId).collection('classes').doc(classId).collection('teachers').doc(teachId).set({
        teachId
    })
}

export default db